import { useEffect, useState } from 'react';
import {
  FaChevronDown,
  FaChevronUp,
  FaSearch,
  FaSort,
  FaFilter,
  FaFileExport,
  FaArrowUp
} from 'react-icons/fa';
import styles from './index.module.css';
import { client } from 'utilities/db';
import { Toasts } from 'components/toasts';
import { RenderIf } from 'utilities/helpers';
import { useStore } from 'store';
import { useCountry } from 'contexts/CountryContext';

function SummaryCards() {
  const { user, branch } = useStore((state) => state);
  const { currencySymbol } = useCountry();
  let branchId = branch?.id;

  const [foodWasteData, setFoodWasteData] = useState({});

  useEffect(() => {
    getInventoryFoodWaste();
  }, []);

  const getInventoryFoodWaste = async () => {
    try {
      const response = await client.get(
        `/inventory/findAllItemsWithUsage/${branchId}`
      );
      if (response?.status === 200 || response?.data?.length > 0) {
        setFoodWasteData(response?.data);
      } else {
        Toasts.error('No items found in the reciept');
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={styles.summaryRow}>
      <div className={styles.summaryCard}>
        <div className={styles.summaryCardHeader}>
          <span className={styles.summaryTitle}>Food waste</span>
          <span className={styles.summarySub}>
            {/* Last 7 Days <FaChevronDown className={styles.chevronIcon} /> */}
          </span>
        </div>
        <div className={styles.summaryValueRow}>
          <div className={styles.summaryValueCol}>
            <div className={styles.summaryValue}>
              {foodWasteData?.foodWaste?.items}
            </div>
            <div className={styles.summaryLabel}>No. of Items</div>
          </div>
          <div className={styles.summaryValueCol}>
            <div className={styles.summaryValue} style={{ fontWeight: 700 }}>
              {currencySymbol}
              {foodWasteData?.foodWaste?.cost || 0}
            </div>
            <div className={styles.summaryLabel}>Cost</div>
          </div>
          <div className={styles.summaryValueCol}>
            <div
              className={styles.summaryValue}
              style={{ fontWeight: 700, lineHeight: '1.2' }}
            >
              {foodWasteData?.foodWaste?.category?.[0] || '0'}
              <br />
              {foodWasteData?.foodWaste?.category?.[1] || ''}
            </div>
            <div className={styles.summaryLabel}>Category</div>
          </div>
        </div>
      </div>
      <div className={styles.summaryCard}>
        <div className={styles.summaryCardHeader}>
          <span className={styles.summaryTitle}>Close to Expiry</span>
          <span className={styles.summarySub}>
            {/* Last 7 Days <FaChevronDown className={styles.chevronIcon} /> */}
          </span>
        </div>
        <div className={styles.summaryValueRow}>
          <div className={styles.summaryValueCol}>
            <div className={styles.summaryValue}>
              {foodWasteData?.closeToExpiry?.items}
            </div>
            <div className={styles.summaryLabel}>No. of Items</div>
          </div>
          <div className={styles.summaryValueCol}>
            <div className={styles.summaryValue} style={{ fontWeight: 700 }}>
              {foodWasteData?.closeToExpiry?.totalCost}
            </div>
            <div className={styles.summaryLabel}>Cost</div>
          </div>
        </div>
      </div>
      <div className={styles.summaryCard}>
        <div className={styles.summaryCardHeader}>
          <span className={styles.summaryTitle}>Waste Reduction %</span>
          <span className={styles.summarySub}>
            {/* Last 7 Days <FaChevronDown className={styles.chevronIcon} /> */}
          </span>
        </div>
        <div className={styles.summaryPercentRow}>
          <div className={styles.summaryPercent}>
            {foodWasteData?.wasteReduction?.percent || 0}%
          </div>
          <div className={styles.summaryTrendWrap}>
            <span className={styles.summaryTrendIcon}>
              <FaArrowUp />
            </span>
            <span className={styles.summaryTrendText}>
              {foodWasteData?.wasteReduction?.change || 0}%
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

function RecipeAccordionRow({
  open,
  dataType,
  beginning_quantity,
  consumed,
  converted_quantity,
  inventories,
  procured,
  product_name,
  remaining_quantity,
  unit,
  wasted,
  mixture_name,
  rawMaterialIngredient,
  recipes,
  onClick
}) {
  const { currencySymbol } = useCountry();
  console.log('🚀 ~ RecipeAccordionRow ~ recipes:', recipes);
  return (
    <>
      <div
        className={styles.recipeRow}
        onClick={onClick}
        style={{
          cursor: recipes?.length > 0 ? 'pointer' : 'default'
        }}
      >
        <div className={styles.recipeLeft}>
          <div className={styles.recipeIcon} style={{ background: 'yellow' }} />
          <div>
            <div className={styles.recipeTitle}>Item</div>
            <div className={styles.recipeName}>
              {product_name || mixture_name}
            </div>
          </div>
        </div>
        <div className={styles.recipeStats}>
          <div>
            <div className={styles.recipeStatValue}>{beginning_quantity}</div>
            <div className={styles.recipeStatLabel}>BEGINNING QUANTITY</div>
          </div>
          <div>
            <div className={styles.recipeStatValue}>{remaining_quantity}</div>
            <div className={styles.recipeStatLabel}>REMAINING QUANTITY</div>
          </div>
          <div>
            <div className={styles.recipeStatValue}>{consumed}</div>
            <div className={styles.recipeStatLabel}>CONSUMED</div>
          </div>
          <div>
            <div className={styles.recipeStatValue}>{procured}</div>
            <div className={styles.recipeStatLabel}>PROCURED</div>
          </div>
          <div>
            <div className={styles.recipeStatValue}>{unit}</div>
            <div className={styles.recipeStatLabel}>UNIT</div>
          </div>
          <div>
            <div className={styles.recipeStatValue}>{wasted}</div>
            <div className={styles.recipeStatLabel}>WASTE</div>
          </div>
        </div>
        <RenderIf isTrue={recipes?.length > 0}>
          <div className={styles.recipeAccordionIcon}>
            {open ? <FaChevronUp /> : <FaChevronDown />}
          </div>
        </RenderIf>
      </div>
      {open && recipes?.length > 0 && (
        <div className={styles.recipeAccordionContentRow}>
          {/* <RenderIf isTrue={dataType === 'MIXTURE'}> */}
          {/* Raw item card */}
          <div className={styles.rawSection}>
            <div className={styles.rawLabel}>
              {dataType === 'MIXTURE'
                ? 'Suggested recipes to make with this mixture'
                : 'Suggested recipes to make with this item'}
            </div>
            <RenderIf isTrue={recipes?.length > 0}>
              <div className={styles.overflowXAuto}>
                <div className={styles.suggestedRecipesRow}>
                  {recipes?.map((raw, index) => (
                    <div className={styles.rawCard} key={index}>
                      <div className={styles.rawCardTitle}>
                        {raw?.menuItemName}
                      </div>
                      <div className={styles.rawCardStatusRow}>
                        <div className={styles.rawCardStatusDot} />
                        <div className={styles.rawCardStatusText}>
                          Cost: {currencySymbol}
                          {raw?.price}
                        </div>
                        {/* <div className={styles.rawCardAddBtn}>+</div> */}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </RenderIf>
          </div>
          {/* </RenderIf> */}
          <RenderIf isTrue={inventories?.length > 0}>
            <div>
              {inventories?.map((inv, index) => (
                <div className={styles.rawSection} key={index}>
                  <div className={styles.rawLabel}>
                    Inventory {inv?.batch_number} - Remaining Qty{' '}
                    {remaining_quantity}
                  </div>
                  <RenderIf isTrue={inv?.logs?.length > 0}>
                    <div className={styles.overflowXAuto}>
                      <div className={styles.suggestedRecipesRow}>
                        {inv?.logs?.map((log, idx) => (
                          <div
                            className={
                              (idx + 1) % 2 === 0
                                ? `${styles.suggestedRecipeCard} ${styles.suggestedRecipeBrown}`
                                : `${styles.suggestedRecipeCard} ${styles.suggestedRecipeBlue}`
                            }
                            key={idx}
                          >
                            <div className={styles.suggestedRecipeTitle}>
                              {log?.log_type}
                            </div>
                            <div className={styles.suggestedRecipeStats}>
                              <span>{log?.reason}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </RenderIf>
                </div>
              ))}
            </div>
          </RenderIf>
          <RenderIf isTrue={dataType === 'MIXTURE'}>
            {/* Suggested Recipes */}
            <div className={styles.suggestedRecipesSection}>
              {/* <div className={styles.suggestedRecipesLabel}>
                Suggested Recipes to make with This mixture and raw items
              </div> */}
              {/* <RenderIf isTrue={recipes?.length > 0}>
                <div className={styles.overflowXAuto}>
                  <div className={styles.suggestedRecipesRow}>
                    {recipes?.map((recipe, idx) => (
                      <div
                        className={
                          (idx + 1) % 2 === 0
                            ? `${styles.suggestedRecipeCard} ${styles.suggestedRecipeBrown}`
                            : `${styles.suggestedRecipeCard} ${styles.suggestedRecipeBlue}`
                        }
                        key={idx}
                      >
                        <div className={styles.suggestedRecipeTitle}>
                          {recipe?.menuItemName}
                        </div>
                        <div className={styles.suggestedRecipeStats}>
                          <span>Cost: {recipe?.price}</span>
                          <span>Can Make: {recipe?.canMake}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </RenderIf> */}
            </div>
            {/* Suggested Deals */}
            {/* <div className={styles.suggestedDealsSection}>
              <div className={styles.suggestedDealsLabel}>
                Suggested Deals with this Recipe
              </div>
              <div className={styles.suggestedDealCard}>
                <div className={styles.suggestedDealCardHeader}>
                  <span className={styles.suggestedDealCardValid}>
                    Valid till 10/10/2024
                  </span>
                  <span className={styles.suggestedDealCardType}>Dine in</span>
                </div>
                <div className={styles.suggestedDealCardTitleRow}>
                  <span className={styles.suggestedDealCardImg}></span>
                  <span className={styles.suggestedDealCardTitle}>
                    Classic Combo 1
                  </span>
                </div>
                <div className={styles.suggestedDealCardDesc}>
                  1 Smash Burger, 1 Loaded fries, 1 Drink (500ml)
                </div>
              </div>
              <button className={styles.suggestedDealBtn}>
                Apply Discount
              </button>
            </div> */}
          </RenderIf>
        </div>
      )}
    </>
  );
}

export default function Foodwaste() {
  const [activeTab, setActiveTab] = useState('Items');
  const [openIndex, setOpenIndex] = useState(null);
  const [inventoryUsageData, setInventoryUsageData] = useState([]);
  const [mixtureInventoryUsageData, setMixtureInventoryUsageData] = useState(
    []
  );

  console.log(
    '🚀 ~ Foodwaste ~ mixtureInventoryUsageData:',
    mixtureInventoryUsageData
  );
  console.log('🚀 ~ Foodwaste ~ inventoryUsageData:', inventoryUsageData);

  const { user, branch } = useStore((state) => state);
  let branchId = branch?.id;

  useEffect(() => {
    getInventoryUsage();
  }, []);

  const getInventoryUsage = async () => {
    try {
      const response = await client.get(
        `/inventory/findAllItemsWithUsage/${branchId}`
      );
      console.log('🚀 ~ getInventoryUsage ~ response:', response);
      if (response?.status === 200 || response?.data?.data?.length > 0) {
        setInventoryUsageData(response?.data?.inventoryWithLogs);
      } else {
        Toasts.error('No items found in the reciept');
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getMixtureInventoryUsage();
  }, []);

  const getMixtureInventoryUsage = async () => {
    try {
      const response = await client.get(
        `/mixtureInventories/inventoryUsage/${branchId}`
      );
      console.log('🚀 ~ getMixtureInventoryUsage ~ response:', response);
      if (response?.status === 200 || response?.data?.data?.length > 0) {
        setMixtureInventoryUsageData(response?.data?.inventoryWithLogs);
      } else {
        Toasts.error('No items found in the reciept');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAccordionClick = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <div className={styles.foodWastePage}>
      <div
        className={styles.pageTitle}
        style={{ fontSize: '24px', fontWeight: '800' }}
      >
        Food Waste
      </div>
      <div className={styles.pageSubtitle}>Manage all the items food waste</div>

      <SummaryCards />
      <div className={styles.tabsCard}>
        <div className={styles.customTabs}>
          {/* <div
            className={activeTab === 'Mixture' ? styles.tabActive : styles.tab}
            onClick={() => setActiveTab('Mixture')}
          >
            Mixture
          </div> */}
          <div
            className={activeTab === 'Items' ? styles.tabActive : styles.tab}
            onClick={() => setActiveTab('Items')}
          >
            Items
          </div>
        </div>
        <div className={styles.tableActionsRow}>
          <div className={styles.searchBox}>
            <FaSearch /> <input placeholder="Search ..." />
          </div>
          {/* <button className={styles.sortBtn}>
            <FaSort /> Sort by
          </button>
          <button className={styles.filterBtn}>
            <FaFilter /> Filters
          </button> */}
        </div>
        <div>
          {activeTab === 'Mixture' ? (
            <div>
              <div className={styles.recipeTableHeader}>
                <div className={styles.recipeTableTitle}></div>
                <div className={styles.recipeTableStats}>
                  <div>BEGINNING INVENTORY</div>
                  <div>REMAINING QUANTITY</div>
                  <div>CONSUMED</div>
                  <div>PROCURED</div>
                  <div>UNIT</div>
                  <div>WASTE</div>
                </div>
                <div className={styles.recipeAccordionIcon}></div>
              </div>
              {mixtureInventoryUsageData?.map((row, idx) => (
                <RecipeAccordionRow
                  key={idx}
                  {...row}
                  open={openIndex === idx}
                  onClick={() => handleAccordionClick(idx)}
                  dataType={'MIXTURE'}
                />
              ))}
            </div>
          ) : (
            <div>
              <div className={styles.recipeTableHeader}>
                <div className={styles.recipeTableTitle}></div>
                <div className={styles.recipeTableStats}>
                  <div>BEGINNING INVENTORY</div>
                  <div>REMAINING QUANTITY</div>
                  <div>CONSUMED</div>
                  <div>PROCURED</div>
                  <div>UNIT</div>
                  <div>WASTE</div>
                </div>
                <div className={styles.recipeAccordionIcon}></div>
              </div>
              {inventoryUsageData?.map((row, idx) => (
                <RecipeAccordionRow
                  key={idx}
                  {...row}
                  open={openIndex === idx}
                  onClick={() => handleAccordionClick(idx)}
                  dataType={'ITEM'}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
